module.exports = __webpack_public_path__ + "img/icon-fastest-parking@2x.15715a1e.png";